import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import { UpdateCompanyConsentRequest } from '@/types/requests/company-consents'
import { CompanyConsentCollection } from '@/types/responses/companies'

class CompanyConsentService {
  async getCompanyConsents(
    currentCompanyId: number,
  ): Promise<CompanyConsentCollection> {
    const response = await apiService.get(
      `${API_PATH_INTERNAL}/companies/${currentCompanyId}/consents`,
    )

    return response.data
  }

  async updateCompanyConsent(request: UpdateCompanyConsentRequest) {
    const response = await apiService.post(
      `${API_PATH_INTERNAL}/company-consents`,
      request,
    )

    return response.data
  }
}

const companyConsentService = new CompanyConsentService()

export default companyConsentService
